import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Action } from 'src/app/loads-shared/shipment-data/models/action';


export interface DialogData {
  title: string;
  message: string;
  actions: Action[];
}

@Component({
    selector: 'app-shipments-confirm-dialog',
    templateUrl: './shipments-confirm-dialog.component.html',
    styleUrls: ['./shipments-confirm-dialog.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      MatButtonModule,
      MatIconModule
    ]
})
export class ShipmentsConfirmDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit(): void {
  }

}
